<template>
  <!-- 上传配置
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <!-- <el-form-item label="上传地址"> 
      <el-input v-model="ossHost"
                placeholder="请输入上传地址"></el-input>
    </el-form-item>
    <el-form-item label="阿里云地区"> 
      <el-input v-model="ossRegion"
                placeholder="请输入阿里云地区"></el-input>
    </el-form-item> -->
    <el-form-item label="上传目录"> 
      <el-input v-model="ossDir"
                placeholder="请输入上传目录"></el-input>
    </el-form-item>
    <!-- <el-form-item label="容器名称"> 
      <el-input v-model="ossBucket"
                placeholder="请输入容器名称"></el-input>
    </el-form-item> -->
    <!-- <el-form-item label="阿里云账号"> 
      <el-input v-model="accessKeyId"></el-input>
    </el-form-item>
    <el-form-item label="阿里云密钥"> 
      <el-input v-model="accessKeySecret"></el-input>
    </el-form-item> -->
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** 
     *  @name ossHost {String} 上传地址
     *  @name ossRegion {String} 阿里云地区
     *  @name ossDir {String} 上传目录
     *  @name ossBucket {String} 容器名称
     *  @name accessKeyId {String} 账号
     *  @name accessKeySecret {String} 密钥
     *  @author 王汝鹏
     *  @version 2019-09-16
     */
    ...mapComputed({
      ossHost: { 
        parent: i => i.baseOption,
        attr: "ossHost",
      },
      ossRegion: { 
        parent: i => i.baseOption,
        attr: "ossRegion",
      },
      ossDir: { 
        parent: i => i.baseOption,
        attr: "ossDir",
      },
      ossBucket: { 
        parent: i => i.baseOption,
        attr: "ossBucket",
      },
      accessKeyId: { 
        parent: i => i.baseOption,
        attr: "accessKeyId",
      },
      accessKeySecret: { 
        parent: i => i.baseOption,
        attr: "accessKeySecret",
      },
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingUploadConfig.vue